import {
  FETCH_SUPPLIER_LIST,
  RESET_SUPPLIER_LIST,
} from "../../constants/action.constants";

//Storage for data.
const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 20,
  },
};

//Controller for the storage.
const supplierListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUPPLIER_LIST:
      return { list: action.payload, others: action.others };
    case RESET_SUPPLIER_LIST:
      return initialState;
    default:
      return state;
  }
};

export default supplierListReducer;
